const CONST = {
    'ANALYZE_SUCCESS': 'WEBANALYZER/ANALYZE_SUCCESS',
    'ANALYZE_FAILURE': 'WEBANALYZER/ANALYZE_FAILURE',
    'SEND_OTP_SUCCESS': 'WEBANALYZER/SEND_OTP_SUCCESS',
    'SEND_OTP_FAILURE': 'WEBANALYZER/SEND_OTP_FAILURE',
    'VERIFY_OTP_SUCCESS': 'WEBANALYZER/VERIFY_OTP_SUCCESS',
    'VERIFY_OTP_FAILURE': 'WEBANALYZER/VERIFY_OTP_FAILURE',
    'SET_LOADING': 'WEBANALYZER/SET_LOADING',
    'CLEAR_RESULT': 'WEBANALYZER/CLEAR_RESULT',
    'CLEAR_OTP': 'WEBANALYZER/CLEAR_OTP',
    'CHECK_FIX_LIMIT_SUCCESS': 'WEBANALYZER/CHECK_FIX_LIMIT_SUCCESS',
    'CHECK_FIX_LIMIT_FAILURE': 'WEBANALYZER/CHECK_FIX_LIMIT_FAILURE',
    'SUBMIT_LEAD_SUCCESS': 'WEBANALYZER/SUBMIT_LEAD_SUCCESS',
    'SUBMIT_LEAD_FAILURE': 'WEBANALYZER/SUBMIT_LEAD_FAILURE',
}

export default CONST;